module.exports = __webpack_public_path__ + "static/media/minautee_dighe.f016ab9b.png";